// 中国身份证号码
// 一代身份证号是15位的数字，二代身份证都是18位的
// 最后一位校验位除了可能是数字还可能是'X'或'x'，所以有四种可能性：
// a.15位数字
// b.18位数字
// c.17位数字，第十八位是'X'
// d.17位数字，第十八位是'x'
export function useValidateIDCard(idCard: string): boolean {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idCard)
}
export function useValiedateEmail(email: string): boolean {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )
}

export function useValidateSocialCreditCode(code: string): boolean {
  const len = code.length
  return (
    (len === 15 && /([0-9A-Za-z]{15})/.test(code)) ||
    (len === 18 && /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/.test(code)) ||
    (len === 20 && /[0-9A-Za-z]{20}/.test(code))
  )
}
